export const PresenceChannel = {
  namespaced: true,

  state: {
    present: [],
  },

  getters: {
    userIsPresent:
      ({ present }) =>
      (id) =>
        present.includes(id),
  },

  mutations: {
    setPresentUsers(state, users) {
      state.present = [...users.map(({ id }) => id)];
    },

    addUser(state, user) {
      state.present = [...state.present, user.id];
    },

    removeUser(state, user) {
      state.present = [...state.present.filter((id) => id !== user.id)];
    },
  },

  actions: {
    async subscribeToChannel({ commit }, channel) {
      const Echo = (await import('../broadcasting/echo')).default;

      Echo.join(channel)
        .here((users) => commit('setPresentUsers', users))
        .joining((user) => commit('addUser', user))
        .leaving((user) => commit('removeUser', user));
    },
  },
};
